<script>
import _ from 'underscore'
import moment from 'moment'

moment.locale('de-ch')

export default {
    computed: {
        user () {
            return window.store.state.user
        },
        route () {
            if (this.$nextRoute) {
                return this.$nextRoute
            } else {
                return this.$route
            }
        }
    },
    beforeRouteEnter (to, from, next) {
        // The component (this) is not available when beforeRouteEnter() is called,
        // so we emulate it

        // Extract fetchData() from component prototype in route
        const comp = to.matched[0].components.default
        
        if (comp.methods.fetchData) {
            // Context for emulation
            const context = _.extend(comp.data(), {
                $api: window.router.app.$api,
                $route: to,
                route: to,
                user: window.store.state.user
            })

            // Fetch data
            comp.methods.fetchData.call(context).then(() => {
                next(vm => {
                    // Now component is available

                    // Remove simulated attributes
                    delete context.$api
                    delete context.$route
                    delete context.user

                    // Merge data with instantiated component
                    vm.setData(context)
                })
            })
        } else {
            // fetchData() does not exist, render rightaway
            next()
        }
    },
    beforeRouteUpdate (to, from, next) {
        if (this.fetchData) {
            // Update this.$route in context
            const context = _.extend(this, {
                $nextRoute: to
            })

            this.fetchData.call(context).then(next)
        } else {
            next()
        }
    },
    methods: {
        goBack () {
            window.router.back()
        },
        fetchData() { },
        setData(context) {
            _.keys(context).forEach(key => {
                const descriptor = Object.getOwnPropertyDescriptor(this, key)
                if (descriptor !== undefined && descriptor.set !== undefined) {
                    this[key] = context[key]
                }
            })
        },
        listNames (users, totalNumber = null) {
            var parts = _.map(users, user => {
                if (user.id == this.user.id) {
                    return 'Du'
                } else {
                    return user.firstname
                }
            })

            if (totalNumber === null) {
                totalNumber = users.length
            }

            if (totalNumber > 3) {
                parts = parts.slice(0, 2)
                parts.push((totalNumber - parts.length) + ' weitere')
            }

            if (parts.length == 0) {
                return ''
            } else if (parts.length == 1) {
                return parts[0]
            } else {
                return parts.slice(0, -1).join(', ') + ' und ' + parts.slice(-1)
            }
        }
    },
    filters: {
        // Format time as nice string, e.g. "Letzten Montag um 01.50 Uhr"
        time (value) {
            var str = moment.utc(value).local().calendar()
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        // Add sign in front of number, used for ELO
        plusminus (value) {
            if (value >= 0) {
                return '+' + value
            } else {
                return value
            }
        },
        // Display full user name
        name (user) {
            if (user) {
                return user.firstname + ' ' + user.lastname
            } else {
                return ''
            }
        },
        // City with postal code
        city (city) {
            if (city) {
                return `${city.postal_code} ${city.name}`
            } else {
                return ''
            }
        },
        tournament_status (val) {
            return {
                'waiting': 'Auf Spieler warten',
                'in-progress': 'Läuft',
                'completed': 'Beendet'
            }[val]
        },
        award_type (val) {
            return {
                'gold': '1. Platz',
                'silver': '2. Platz'
            }[val]
        },
        round_name (val) {
            return [ 'Finale', 'Halbfinale', 'Viertelfinale', 'Achtelfinale' ][val]
        },
        grade (year) {
            // School year starts August 1st
            const start = new Date(year, 8, 1)

            return Math.ceil(moment.duration(new Date - start).asYears())
        }
    }
}
</script>


// WEBPACK FOOTER //
// base.vue?3c44e364